import { render, staticRenderFns } from "./EmployeeBankInformation.vue?vue&type=template&id=6161c4f7"
import script from "./EmployeeBankInformation.vue?vue&type=script&lang=js"
export * from "./EmployeeBankInformation.vue?vue&type=script&lang=js"
import style0 from "./EmployeeBankInformation.vue?vue&type=style&index=0&id=6161c4f7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports